module.exports = __webpack_public_path__ + "img/new-home-page-guide-drawer-illustration-en3.3278961.png";